/**
 * Router xato sahifasi: React Router'ning xom "Unexpected Application Error" o'rniga. Eng ko'p sabab -- deploy'dan keyin
 * eski JS (yoki yuklanmagan chunk): avval yangi build bormi tekshiriladi va bo'lsa sahifa o'zi yangilanadi (bir marta);
 * aks holda "Yangilash" va "Bosh sahifa" tugmalari, xato matni pastda.
 */
import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { checkVersion, reloadOnce } from "@/lib/version";

const CHUNK_ERROR = /dynamically imported module|ChunkLoadError|Loading chunk|Importing a module script failed/i;

export function AppError() {
  const { t } = useTranslation();
  const error = useRouteError();
  const message = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : String(error);

  useEffect(() => {
    void checkVersion().then((stale) => {
      if (stale || CHUNK_ERROR.test(message)) reloadOnce();
    });
  }, [message]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
      <div className="w-full max-w-[460px] rounded-card border border-border/60 bg-surface p-6 text-center shadow-card">
        <h1 className="text-[20px] font-semibold tracking-[-0.015em]">{t("appError.title")}</h1>
        <p className="mt-2 text-[13px] text-muted">{t("appError.desc")}</p>
        <div className="mt-4 flex justify-center gap-2">
          <Button variant="primary" onClick={() => window.location.reload()}>
            {t("appError.reload")}
          </Button>
          <Button onClick={() => window.location.assign("/")}>{t("appError.home")}</Button>
        </div>
        <pre className="mt-4 max-h-28 overflow-auto rounded-[10px] bg-fill p-3 text-left text-[11px] whitespace-pre-wrap text-ink-soft">{message}</pre>
      </div>
    </div>
  );
}
